var ArmorUse = {
  handle: 'armor_use',

  abilities: {
    layers_of_protection: {
      handle: 'layers_of_protection',
      unlockLevel: 1,
      passive: true,
    },

    shield_block: {
      handle: 'shield_block',
      unlockLevel: 8,
    },

    bash: {
      handle: 'bash',
      unlockLevel: 16,
    },

    missile_defense: {
      handle: 'missile_defense',
      unlockLevel: 24,
      passive: true,
    },

    suture: {
      handle: 'suture',
      unlockLevel: 32,
    },

    armor_spikes: {
      handle: 'armor_spikes',
      unlockLevel: 40,
      passive: true,
    },

    reflect_magic: {
      handle: 'reflect_magic',
      unlockLevel: 48,
      passive: true,
    },
  },

};
module.exports = ArmorUse;